import { computed, ref } from "vue";
import Address from "src/composables/Address";
import Utilities from "src/composables/Utilities";

const { mmddyyyy_to_yyyymmdd, yyyymmdd_to_mmddyyyy } = Utilities();

const first_name = ref(null);
const last_name = ref(null);

const date_of_birth = ref(null)
const email = ref(null);
const confirm_email = ref(null);
const phone_number = ref(null);
// const social_security_number = ref(null);
const current_address = ref(Address());
const billing_address = ref(Address());
const spanish = ref(false);
const electronic_billing = ref(false);
const paperless_billing = ref(false);
// const drivers_license_number = ref(null);
// const drivers_license_state = ref(null);

const clear_all_customer_information = function () {
    first_name.value = null;
    last_name.value = null;
    date_of_birth.value = null;
    email.value = null;
    phone_number.value = null;
    // social_security_number.value = null;
    // drivers_license_state.value = null;
    // drivers_license_number.value = null;
    spanish.value = false;
    electronic_billing.value = false;
    paperless_billing.value = false;
    current_address.value.clear_address();
    billing_address.value.clear_address();
}

const customer_information_valid = computed(() =>
    !!first_name.value &&
    !!last_name.value &&
    !!email.value &&
    email.value === confirm_email.value &&
    !!phone_number.value &&
    phone_number.value.length === 10 &&
    !!date_of_birth.value &&
    !!billing_address.value?.is_valid
)

export default () => {
    return {
        first_name,
        last_name,
        date_of_birth,
        email,
        confirm_email,
        phone_number,
        // social_security_number,
        // drivers_license_number,
        // drivers_license_state,
        current_address,
        billing_address,
        spanish,
        electronic_billing,
        paperless_billing,
        clear_all_customer_information,
        customer_information_valid
    }
}
